import { isObject, isFunction } from 'lodash-es';
import { analyticsLib } from '../lib';
import type { AnalyticsEvent, AppAnalytics } from '../types';

declare global {
  interface Window {
    gtag(
      type: 'event',
      eventName: string,
      params: Record<string, unknown>,
    ): void;
  }
}

type ErrorHandler = (error: unknown) => void;
type AnalyticsParams = {
  prefix?: string;
  onError?: ErrorHandler;
};

export class WebAnalytics implements AppAnalytics {
  prefix: string;

  onError?: ErrorHandler;

  constructor({ prefix = '', onError }: AnalyticsParams = {}) {
    this.prefix = prefix;
    this.onError = onError;
  }

  logEvent(originalEvent: AnalyticsEvent) {
    if (typeof window === 'undefined' || !window.gtag) {
      return;
    }

    const { event, action, label } = analyticsLib.getPrefixedEvent(
      this.prefix,
      originalEvent,
    );
    /**
     * TODO: We want to send any params, not only action and event.
     * We need to rethink the way we send events from code.
     * As for now send action as arbitrary object and dismiss label in that case
     */
    const eventParams = isObject(action)
      ? action
      : {
          action,
          label,
        };

    try {
      window.gtag('event', event, eventParams);
    } catch (error) {
      if (isFunction(this.onError)) {
        this.onError(error);
      }
    }
  }
}
